<template>
    <div class="choice-container">
        <div class="choice-card card-body">
            <h2 class="h2-title">Твой выбор</h2>
            <p class="choice-description">
                Прежде, чем двигаться дальше, тебе нужно выбрать вызов, в котором ты будешь выполнять все следующие
                задания конкурса. Ты можешь оставить тот, который выпал по результатам тестов, или перейти в другой.
            </p>
            <p class="choice-description">
                Познакомься с каждым из вызовов, посмотри материалы в образовательных треках и выбери тот, что тебе
                ближе всего. Но обязательно сделай это до 25 июня. Потом поменять вызов уже не получится.
            </p>
            <button @click="$emit('openModal')" class="btn-unstyled btn-default">Поменять вызов</button>
        </div>

        <div class="choice-cta">
            <h3 class="choice-cta-title">
                Вырвись вперед! Получи <span class="marked-accent-2">10 баллов</span> дополнительно
            </h3>
            <p class="choice-cta-description">
                Когда изучишь материалы в своем вызове, ответь на 5 несложных вопросов.
            </p>
            <p class="choice-cta-description">За это в конце этапа тебе начислят дополнительные баллы.</p>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="css">
.choice-container {
    display: flex;
    flex-direction: row;
}
.choice-card {
    flex: 1;
    border-bottom: 4px solid var(--main);
}
.choice-description {
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 24px;
}
.choice-cta {
    margin-left: 16px;
    flex: 0 0 200px;
    background-color: #fff;
    padding: 24px 12px;
    margin-bottom: 16px;
    background-image: url('https://storage.yandexcloud.net/proektoria-education/static/images/choice-bottom.svg');
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: 100%;
    padding-bottom: 60px;
}
.choice-cta-title {
    font-weight: bold;
    font-size: 16px;
    line-height: 110%;
    margin-bottom: 16px;
    color: #262629;
}
.choice-cta-description {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 120%;
    color: #404044;
    opacity: 0.8;
    margin-bottom: 16px;
}
@media (max-width: 992px) {
    .choice-container {
        flex-direction: column;
    }
    .choice-cta {
        flex: 1;
        margin-left: 0;
        background-size: 100%;
        background-position: 0 100px;
    }
}
</style>
